import dance1 from '../assets/Artist/dancer/Sukalyan/sukalyan9.png'
import d1 from '../assets/Artist/dancer/Sukalyan/sukalyan1.png'
import d2 from '../assets/Artist/dancer/Sukalyan/sukalyan2.png'
import d3 from '../assets/Artist/dancer/Sukalyan/sukalyan3.png'
import d4 from '../assets/Artist/dancer/Sukalyan/sukalyan4.png'
import d5 from '../assets/Artist/dancer/Sukalyan/sukalyan5.png'
// import d6 from '../assets/Artist/dancer/Sukalyan/sukalyan6.png'
import d7 from '../assets/Artist/dancer/Sukalyan/sukalyan7.png'
import d8 from '../assets/Artist/dancer/Sukalyan/sukalyan8.png'
import d9 from '../assets/Artist/dancer/Sukalyan/sukalyan10.png'
import d10 from '../assets/Artist/dancer/Sukalyan/sukalyan11.png'
import d11 from '../assets/Artist/dancer/Sukalyan/sukalyan12.png'
import d12 from '../assets/Artist/dancer/Sukalyan/sukalyan13.png'
import d13 from '../assets/Artist/dancer/Sukalyan/sukalyan14.png'

import dance2 from '../assets/Artist/dancer/Aditya G/main.jpeg'
import AG1 from '../assets/Artist/dancer/Aditya G/ag2.jpeg'
import AG2 from '../assets/Artist/dancer/Aditya G/ag3.jpeg'


import aradhana from '../assets/Artist/dancer/Aaradhana D/WhatsApp Image 2025-05-12 at 16.13.09_ba50c11f.jpg'
import ar1 from '../assets/Artist/dancer/Aaradhana D/WhatsApp Image 2025-05-12 at 16.13.09_c61b8202.jpg'

import aneri from '../assets/Artist/dancer/Aneri S/main.jpg'
import aneri1 from '../assets/Artist/dancer/Aneri S/WhatsApp Image 2025-05-12 at 16.14.19_664615bd.jpg'

import monalisa from '../assets/Artist/dancer/Bidushi Monalisa G/main.jpg'
import mona1 from '../assets/Artist/dancer/Bidushi Monalisa G/IMG-20250510-WA0049.jpg'

import wro from '../assets/Artist/dancer/we are one/WhatsApp Image 2025-05-14 at 10.44.25 PM.jpeg'
import wro1 from '../assets/Artist/dancer/we are one/DSC08637.jpg'
import wro2 from '../assets/Artist/dancer/we are one/DSC08649.jpg'
import wro3 from '../assets/Artist/dancer/we are one/DSC_0191.jpg'
import wro4 from '../assets/Artist/dancer/we are one/PSS06263.jpg'
import wro5 from '../assets/Artist/dancer/we are one/PSS06480.jpg'
import wro6 from '../assets/Artist/dancer/we are one/_A7R2341.jpg'

import nijara from "../assets/Artist/dancer/Nijara N/nijara.png"
import nijara1 from '../assets/Artist/dancer/Nijara N/WhatsApp Image 2025-05-13 at 15.26.52_370f789d.jpg'

import shruti from '../assets/Artist/dancer/Shruti R/shruti.png'
import babu from '../assets/Artist/dancer/Anita B/anita.png'
import babu1 from '../assets/Artist/dancer/Anita B/babu1.jpeg'

import dance3 from '../assets/Artist/dancer/Umesh D/main.jpeg'
import UD1 from '../assets/Artist/dancer/Umesh D/info1.jpeg'
import UD2 from '../assets/Artist/dancer/Umesh D/info2.jpeg'

import neetu from '../assets/Artist/Singer/Neetu kumari/WhatsApp Image 2025-05-26 at 1.30.45 PM.jpeg'
import nk1 from '../assets/Artist/Singer/Neetu kumari/WhatsApp Image 2025-05-12 at 16.13.27_84b20404.jpg'

import deene from "../assets/Artist/Singer/deenekhan/main.jpg"
import deene1 from '../assets/Artist/Singer/deenekhan/IMG_0031.jpg'
import deene2 from "../assets/Artist/Singer/deenekhan/IMG_0032.jpg"
import deene3 from "../assets/Artist/Singer/deenekhan/IMG_0033.jpg"
import deene4 from "../assets/Artist/Singer/deenekhan/IMG_0035.jpg"
import deene5 from "../assets/Artist/Singer/deenekhan/IMG_0036.jpg"

import salil from '../assets/Artist/Singer/Salil latay/main.jpg'
import sal1 from "../assets/Artist/Singer/Salil latay/WhatsApp Image 2025-05-12 at 16.13.49_7db2273e.jpg";
import sal2 from "../assets/Artist/Singer/Salil latay/WhatsApp Image 2025-05-12 at 16.13.50_a742b1fb.jpg"


import pramod from '../assets/Artist/theater/PramodJadhav/pramod.png'
import zafar from '../assets/Artist/theater/zafar/WhatsApp Image 2025-05-10 at 17.20.33_3d2d153b.jpg'


import mategaonkar from '../assets/Artist/Singer/mategaonkar/WhatsApp Image 2025-05-20 at 9.43.00 AM (2).jpeg'
import sandeep from '../assets/Artist/theater/sandeep/Adobe Express - file.jpg'

import ambrosia from "../assets/Artist/theater/ambrosia/ambrosia.jpeg";
import am1 from "../assets/Artist/theater/ambrosia/am1.jpeg";
import am2 from "../assets/Artist/theater/ambrosia/am2.jpeg";
import am3 from "../assets/Artist/theater/ambrosia/am3.jpeg";

import kundan from "../assets/Artist/theater/Kundan Kumar/profile.jpeg";
import k1 from "../assets/Artist/theater/Kundan Kumar/info1.jpeg";
import k2 from "../assets/Artist/theater/Kundan Kumar/info2.jpeg";




const allArtists = {
  Dancers: [
    {
      name: "Umesh D",
      city: "Mumbai, Maharashtra",
      tags: ["Fusion Dancer", "Folk", "15+ years"],
      image: dance3,
      about: "Bollywood Coreographer ",
      description: `Umesh D is a choreographer and performer known for curating and directing dance-based stage productions, 
        cultural showcases, school and college annual functions, and corporate performances. His work spans Bollywood, folk,
         and thematic dance choreography, with experience in large-group performances and event-based productions. Through his 
         YouTube channel, he regularly showcases choreography projects, live performances, and creative dance concepts across community 
          and institutional platforms`,
      performances: [UD1, UD2],
      form:"Bollywood versatile Choreography "
    },

    {
      name: "Sukalyan B",
      city: "Kolkata, West Bengal",
      tags: ["Dancer","Theatre Artist" ,"25+ years","Fusion Dance", ],
      image: dance1,
      about: "Fusion Dance ",
      description:
        "Sukalyan B is a leading Kolkata-based Fusion Dancer and choreographer. He founded the Sukalyan D Entourage troupe in 1995 telegraph india and has over 25 years of experience producing innovative dance programs. Trained in classical and contemporary forms, he choreographs shows blending Bharatnatyam, Kathak and folk styles. His troupe has staged performances at prestigious venues in India and abroad, including the North American Bengali Conference (USA), Banga Sammelans in the US and Canada, and Kolkata’s Rabindra Sadan. Renowned for his creative repertoire, Sukalyan has been praised by cultural luminaries and regularly features in major cultural festivals.",
      performances: [d9, d7, d8,  ],
      form:"Fusion"
    },

    {
      name: "Aditya G",
      city: "Mumbai, Maharashtra",
      tags: ["Classical Dancer", "Kathak", "10+ years"],
      image: dance2,
      about: "Kathak ",
      description: `Aditya G is a Mumbai-based Kathak exponent and choreographer, with over a decade of formal training.  
He received his Kathak Visharad diploma from the Akhil Bharatiya Gandharva Mahavidyalaya and studied under Guru Pt. Mayur Vaidya for 10+ years. 
He also assisted Kathak legend Pt. Birju Maharaj and incorporates Banaras and Lucknow gharana techniques into his style. 
Aditya has performed widely in India and abroad. Notable performances include the Azadi Ka Amrit Mahotsav celebrations in Central Asia and major festivals in Pune and Chhattisgarh. 
His achievements include a diplomatic “white” passport for representing India internationally, and accolades from Kathak masters.`,
      performances: [AG1, AG2],
      form:"kathak "
    },

    {
      name: "Monalisa G ",
      city: "West Bengal",
      tags: ["Classical Dancer", "40+ years","Odissi", ],
      image: mona1,
      about: " Odissi ",
      description:
        "Monalisa Ghosh is a veteran Odissi dancer and the director of Kalajyoti, a gurukul near Kolkata. An Odissi Nrityoshri, she was trained by the great Kelucharan Mahapatra and Sanjukta Panigrahi. With over 40 years on stage (since the early 1980s), she has performed at premier dance festivals across India and internationally — including the USA, UK, Europe, Middle East, Bangladesh, and Tajikistan. Her dance is noted for its classicism and lyrical depth. Monalisa is also a social activist and scholar: she’s lectured on dance’s therapeutic and spiritual aspects. Among her honors, she has been cited in major publications and has led efforts to promote Indian spiritual values through art.",
      performances: [monalisa],
      form:"Odissi "
    },

    {
      name: "Aneri S ",
      city: "Mumbai, Maharshtra ",
      tags: ["Classical Dancer", "Moihiniattam"],
      image: aneri,
      about: "Mohiniyattam ",
      description:
        "Aneri S is a Mumbai-based Mohiniyattam dancer known for her graceful performances. She trained for several years under Guru Mandakini Trivedi at Nateshvari Dance Gurukul in Mumbai. Aneri’s work combines classical rigour with research: she was awarded the 2021–22 Kolkata Centre for Creativity Arts Fellowship for her project “Journey of the Goddess in the Kerala Performing Arts.” She has performed in Mumbai and at cultural programs, including NCPA lecture-demonstrations, presenting Mohiniyattam repertoire. While continuing intensive training, Aneri builds bridges between classical dance and contemporary themes — a focus recognized by her recent fellowship and performances.",
      performances: [aneri1],
      form:"Mohiniyattam  "
    },

    {
      name: "Aradhana S ",
      city: "Pune, Maharshtra",
      tags: ["Classical Dancer", "15+ years", "Odissi"],
      image: aradhana,
      about: "Odissi ",
      description:
        "Aradhana S is a Pune-based Odissi artist with over 15 years of experience. Trained under Guru Shri Niranjan Rout, she brings rich lyrical expression and technical precision to the Banaras gharana of Odissi. Aradhana has performed in major cultural events in Maharashtra, showcasing traditional Odissi items like Shiva Tandava Stotram. Her dance has been featured at university festivals and state-level dance programs in Pune. She continues to explore Odissi’s connection with yoga and Sanskrit texts, supported by her training at Ravi Shankar Sanskrutik Sansthan and active participation in Pune’s classical dance circles.",
      performances: [ar1],
      form:"Odissi "
    },

    {
      name: "We Are One",
      city: "Delhi",
      tags: ["Disability", "Fusion Dance"],
      image: wro,
      about: " Disability Ensemble",
      description: `We Are One is a Delhi-based inclusive dance collective led by wheelchair dancer Husnain, bringing together performers with physical and hearing impairments. The ensemble creates choreography for wheelchair and adaptive dance styles, often fusing classical and contemporary elements—such as in their acclaimed piece Shiv Tandav on Wheels.

Husnain has been honored by Presidents Pranab Mukherjee and APJ Abdul Kalam, as well as Singapore’s President Halimah Yacob, in recognition of his vision for inclusive art.

The troupe has toured internationally, performing in more than 10 countries including the USA, UK, Canada, Russia, Italy, and Singapore, demonstrating that disability is no barrier to artistic excellence. We Are One captivates audiences with performances that blend Indian rhythms with global dance styles.`,
      performances: [wro1, wro3, wro4,],
      form:"Fusion "
    },
    {
      name: "Nijara N",
      city: "Guwahati, Assam",
      tags: ["Classical Dancer", "Sattriya"],
      image: nijara,
      about: "Sattriya",
      description: `Nijara N is a Sattriya dancer from Guwahati, Assam. Trained in the devotional Sattriya tradition of the Assamese Satras, she embodies the stylistic purity passed down by the bhakats. Nijara has performed in Assam’s major cultural programs and Sattriya festivals, presenting traditional dance-dramas and Bishtanayika sequences. She is noted for her expressive footwork and compelling storytelling. Nijara frequently performs at Sankari Sanskritik Mahotsavs and university Natya Utsavs. Her mastery of Bhupali and Shyam Kirtan compositions has earned her acclaim within Assam’s dance community. A graduate of Srimanta Sankaradeva University of Culture, Nijara carries forward the rich legacy of Srimanta Sankardeva’s dance tradition.`,
      performances: [nijara1],
      form:"Sattriya "
    },
    {
      name: "Anita B",
      city: "Delhi",
      tags: [
        "Classical dancer",
        "30+ years","Odissi"
        
      ],
      image: babu,
      about: "Odissi",
      description: `Anita B is a renowned Odissi dancer, choreographer, and educator based in Delhi, with over 30 years of performance experience and more than 15 years dedicated to teaching and choreography. A senior disciple of Padmashree Guru Gangadhar Pradhan and mentee of Padmashree Aruna Mohanty, she founded Odissi Natya Sala in 1999, affiliated with Pracheen Kala Kendra. An empanelled artist with ICCR and Doordarshan since the 1990s, Anita has graced prestigious stages such as the Konark Dance Festival, International Yoga Festival, and international venues in the USA and Nepal. Her accolades include the REX Karmaveer Global Fellowship (2015–16), Women Leadership Achievement Award (2016), and the Femina Women Super Achievers Award (2017). Known for her socially-driven choreographies, Anita B harnesses the power of classical dance to inspire social awareness and change.`,
      performances: [babu1],
      form:"Odissi "
    },

    {
      name: "Shruti R",
      city: "Pune, Maharashtra",
      tags: ["Classical Dancer", "Bharatanatyam"],
      image: shruti,
      about: "Bharatanatyam",
      description: `Shruti R is a Pune-based Bharatanatyam dancer and educator with over 17 years of training. She studied under Guru Aparna Dhupkar for 13 years and Guru Vaibhav Arekar for 4 years, specializing in the Pandanallur style. A Doordarshan-graded artist, Shruti has performed at leading dance festivals across Maharashtra and was honored with the V.D. Paluskar Award for her excellence in classical dance. As a member of the Sankhya Dance Company, she has toured nationally, and through her outreach work with the Baithak Foundation, she brings Bharatanatyam to underprivileged children. Shruti is known for her crisp adavus, expressive abhinaya, and her deep commitment to spreading classical dance through both performance and pedagogy.`,
      performances: [],
      form:"Bharatanatyam"
    },
  ],

  Singers: [
    {
      name: "Dr. Nitu Kumari N",
      city: "Patna, Bihar",
      tags: [
        "Singer",
        "Folk-music",
        "30+ years",
        
      ],
      image: neetu,
      about: "Folk Music",
      description: `Dr. Nitu Kumari N of Patna is a leading exponent of Bihar’s folk music. With a PhD in music and training under maestros like Lata Mangeshkar and Pandit Ram Singh, she has spent nearly 30 years promoting Bhojpuri, Maithili, and other regional folk traditions. A Sangeet Natak Akademi Awardee and a graded artist with All India Radio and Doordarshan, Dr. Nitu was honored as the first female “Rajya Guru” for folk music in Bihar by the SNA. Her accolades include the Lokvidh Samman and the Lata Mangeshkar Swar Kokila Award. In addition to her performances across India and abroad, she actively lectures on folk traditions and leads village-based music programs, serving as a true cultural ambassador for Bihar.`,
      performances: [nk1],
      form:"Folk Music"
    },
    {
      name: "Deene K",
      city: "Jaisalmer, Rajasthan",
      tags: ["Singer", "Traditional folk", ],
      image: deene,
      about: "Rajasthani Folk Music",
      description: `Deene K is a legendary Manganiyar singer from Jaisalmer, Rajasthan, carrying forward a 15-generation legacy of desert music. Renowned for his soulful renditions of Rajasthani folk and Sufi compositions, his deep, resonant voice and vibrant performance style have captivated audiences at both traditional heritage festivals and contemporary cultural stages. His repertoire spans wedding ballads (Manganiyar geet), devotional bhajans, and storytelling songs, often accompanied by traditional instruments like the dholak and kamaicha. Deene K has toured across India—from Udaipur to Delhi—and continues to share the rich Manganiyar heritage with international audiences.`,
      performances: [, deene3, deene4, deene5],
      form: "Rajasthani Folk Music"
    },
    {
      name: "Dr. Salil L",
      city: "Pune, Maharashtra",
      tags: ["Singer","Musician", "Vocalist", ],
      image: salil,
      about: "Musician",
      description: `Dr. Salil L is a Pune-based vocalist and composer specializing in Hindustani light music, particularly ghazals and romantic melodies. Holding a doctorate in music, he leads performances under his unique “Vocal Sonata” format, blending Hindi-Urdu ghazals with film songs. His Mission of Melody series emphasizes soulful, melody-driven renditions. Known for his emotive light ghazals and soft romantic songs, Salil has performed at major music events and concerts in Pune. His recordings, such as Sukoon Bhare Nagme, have gained wide appreciation. Dr. Latay’s work elegantly bridges classical poetics with a modern sensibility, making him a celebrated figure in contemporary Sugam Sangeet.

`,
      performances: [sal1, sal2],
      form:" Romantic melodies"
    },
  ],

  Musicians: [
    {
      name: "Yogesh M",
      city: "Mumbai, Maharashtra",
      tags: ["Tabla" , "Instrumental","20+ Years"],
      image: mategaonkar, // Replace with actual image URL
      about: " Tabla",
      description: `Yogesh M is a Mumbai-based tabla artist and the founder of the Suranjali music ensemble. A representative of the Jaipur gharana, he brings over 20 years of experience in tabla solo recitals and accompaniment for vocal and instrumental performances. Through Suranjali, he curates innovative fusion programs that blend Hindustani tabla with Sufi, qawwali, Bollywood orchestration, and Western styles. Yogesh has performed extensively at cultural festivals, corporate gatherings, and national award functions. His versatility as a percussionist and composer has earned him recognition through television appearances and studio recordings, helping bring the tabla to wider audiences.`,
      performances: [],
      form:"Tabla "
    },
  ],

  Theatre: [
    {
      name: "Kundan K",
      city: "Mumbai, Maharashtra",
      tags: ["Actor", "Drama","Dance","15+ years"],
      image: kundan,
      about: "Dance, Drama ",
      description: `Kundan K is an accomplished theatre director, actor, and cultural practitioner from Begusarai, Bihar. A graduate of the prestigious National School of Drama, he has worked with renowned theatre directors and has directed and performed in numerous productions across India. With over two decades of experience in theatre, Kundan has actively contributed to the development of performing arts through productions, workshops, and youth theatre initiatives. He is the founder of The Players Act and has played a key role in promoting theatre culture by organizing national theatre festivals and recognizing outstanding contributions to the arts. Kundan K continues to work actively in theatre and performance, contributing to the preservation and promotion of India’s rich cultural and artistic heritage.`,
      performances: [k1, k2],
      form:"Theatre"
    },
    {
      name: "Pramod J",
      city: "Mumbai, Maharashtra",
      tags: ["Actor", "Drama","Dance","15+ years"],
      image: pramod,
      about: "Dance, Drama ",
      description: `Pramod J is a Mumbai-based performer and director known for his work in dance-theatre and drama. With over 15 years of stage experience, he blends choreography seamlessly with acting. A graduate of a premier performing arts institution, Pramod has directed a variety of Marathi and Hindi plays as well as dance-dramas, which have been featured across Mumbai’s theatre circuit. His productions have appeared at city cultural centers and corporate events. In addition to directing, he also composes music and designs sets, establishing himself as a versatile theatre-maker. His notable works include contemporary interpretations of Indian folktales and mythologies, presented at venues such as Kalagram and local community theaters. Pramod continues to train under senior theatre mentors and conducts workshops for aspiring performers.`,
      performances: [],
      form:"Theatre"
    },
    {
      name: "Sandeep Y",
      city: "Prayagraj, Uttar Pradesh",
      tags: ["Actor", "Model", "15+ years", ,"Theatre"],
      image: sandeep,
      about: "Modern Theatre",
      description: `Sandeep Y is a modern theatre practitioner from Prayagraj (Allahabad). Beginning with Nautanki folk theatre in 2009, he later earned a Master of Performing Arts in Theatre Arts from the University of Hyderabad. He has directed and acted in numerous productions, including his award-winning play BUTTERFLY, which was supported by a Government of India theatre grant. His short film Gateway to Heaven received a Special Mention at the 4th Mumbai International Film Festival. Sandeep is also active as a costume designer and acting coach. He has performed at national theatre festivals and collaborated with international groups, including those based in Singapore. His work often explores social themes through an intercultural lens, shaped by his formal theatre training.`,
      performances: [],
      form:"Theatre"
    },
    {
      name: "Kaleem Z",
      city: "Mathura, Uttar Pradesh",
      tags: [
        "Actor, Director",
        "Theatre",
        "10+ years",
        ,
      ],
      image: zafar,
      about: "Modern Drama",
      description: `Kaleem Z is a Mathura-born, Mumbai-based theatre artist: actor, director, writer, lyricist, and composer. He trained at the Intercultural Theatre Institute (Singapore) and the Madhya Pradesh School of Drama. Kaleem co-founded Sanket Rangtoli in Delhi and later led the National School of Drama’s Theatre-in-Education company. He has acted in films and series such as Delhi Crime and teaches at Barry John Acting Studio. An expert in children’s theatre, he has directed youth plays across India. As founder-trustee of the Own Spac trust, Kaleem produces experimental theatre and composes music and songs for the stage. His career spans three decades of stage and screen, marked by numerous festival productions and a passion for arts education.`,
      performances: [],
      form:"Theatre "
    },
    {
      name: "Ambrosia",
      city: "Mumbai, Maharashtra",
      tags: [
        "Actor",
        "Theatre",
        "10+ years",
        ,
      ],
      image: ambrosia,
      about: "Modern Drama",
      description: `Ambrosia is a theatre group dedicated to providing exceptional acting training and stage performances. Founded by a group of passionate theatre enthusiasts, it has  been providing training and performance opportunities to aspiring actors and actresses of all ages and abilities for 11 years. They have trained over 600 actors across 50+ batches and produced over 28 stage productions. They have experienced faculty, including acting instructors and directors.`,
      performances: [am1, am2, am3],
      form:"Theatre "
    },
  ],
};

export default allArtists;
